/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A broker asks the validators of the tunnel to validate one of his quotes.
 * @export
 * @interface DemanderValidationCommand
 */
export interface DemanderValidationCommand {
    /**
     * Optional message of the broker to the validators.
     * @type {string}
     * @memberof DemanderValidationCommand
     */
    message?: string | null;
}

/**
 * Check if a given object implements the DemanderValidationCommand interface.
 */
export function instanceOfDemanderValidationCommand(value: object): value is DemanderValidationCommand {
    return true;
}

export function DemanderValidationCommandFromJSON(json: any): DemanderValidationCommand {
    return DemanderValidationCommandFromJSONTyped(json, false);
}

export function DemanderValidationCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): DemanderValidationCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function DemanderValidationCommandToJSON(json: any): DemanderValidationCommand {
    return DemanderValidationCommandToJSONTyped(json, false);
}

export function DemanderValidationCommandToJSONTyped(value?: DemanderValidationCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
    };
}

